/* Détection d'écriture.
   Un texte n'est traité comme arabe (dir="rtl", police arabe, bouton de
   prononciation) que s'il ne contient AUCUNE lettre latine. Une phrase
   française citant un mot arabe reste en LTR : le navigateur place déjà
   le segment arabe correctement grâce à l'algorithme bidi, alors qu'un
   dir="rtl" global renverrait la ponctuation et les mots latins à
   l'envers. */
const ARABIC = /[\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFF]/;
const LATIN = /[A-Za-z\u00C0-\u024F]/;

export const hasArabic = (s) => ARABIC.test(s || "");

export const isFullyArabic = (s) => {
   const t = String(s || "").trim();
   if (!t) return false;
   return ARABIC.test(t) && !LATIN.test(t);
};
